import { Box, Typography, LinearProgress, useTheme, Stack } from '@mui/material';
import { LessonProgress } from '@models/LessonProgress';
import { formatDateToCustomString, formatTimeSpanToCustomString, millisecondsToTimeSpan } from 'helpers/dateHelper';
import HistoryIcon from '@mui/icons-material/History';
import { useTranslation } from 'react-i18next';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import {
  HistoryIconBox,
  DateBox,
  VersionBox,
  PercentageBox,
  ProgressBox,
  StyledLinearProgress,
  TimeBox,
  StyledAccessAlarmIcon,
  PointsBox
} from './HistoricalProgresses.styles';
import { LessonProgressStatus } from "models/LessonProgressStatus";

interface HistoricalProgressesProps {
    historicalProgresses: LessonProgress[];
}

const HistoricalProgresses: React.FC<HistoricalProgressesProps> = ({ historicalProgresses }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const fontSize = '14px';

    return (
        <Stack spacing={theme.spacing(2)} padding={theme.spacing(2)}>
            {historicalProgresses.map((hp, index) => (
                <Stack key={index} direction={'row'} width={'100%'} display={'flex'} justifyContent={'space-between'} paddingLeft={theme.spacing(2)} alignItems={'center'}>
                    <HistoryIconBox>
                        <HistoryIcon />
                    </HistoryIconBox>
                    <DateBox>
                        <Typography fontSize={fontSize}>{!hp.completedAt ? formatDateToCustomString(hp.createdAt) : formatDateToCustomString(hp.completedAt)}</Typography>
                    </DateBox>
                    <VersionBox>
                        <Typography fontSize={fontSize}>{`v${hp.lessonVersion.version}`}</Typography>
                    </VersionBox>
                    <PercentageBox>
                        <Box width='100%' display='flex' flexDirection={'row'} justifyContent={'flex-end'} paddingLeft={theme.spacing(2)} paddingRight={theme.spacing(2)}>
                            <Typography fontSize={fontSize}>{(hp.pointsScored / hp.lessonVersion.maxPoints * 100).toFixed(0) + ' %'}</Typography>
                        </Box>
                    </PercentageBox>
                    <ProgressBox>
                        <StyledLinearProgress variant="determinate"
                            value={hp.pointsScored / hp.lessonVersion.maxPoints * 100}
                        />
                    </ProgressBox>                    
                    <TimeBox>
                        <Box width='100%' display='flex' flexDirection={'row'} justifyContent={'flex-start'} paddingLeft={theme.spacing(2)} paddingRight={theme.spacing(2)}>
                            <StyledAccessAlarmIcon fontSize='small'/>
                            <Typography fontSize={fontSize}>
                                {(hp.lessonProgressStatus !== LessonProgressStatus.Finished || !hp.completedAt)
                                    ? t('myTrainings.historicalProgress.notFinished')
                                    : formatTimeSpanToCustomString(millisecondsToTimeSpan(
                                        new Date(hp.completedAt).getTime() - new Date(hp.createdAt).getTime()))}
                            </Typography>
                        </Box>                        
                    </TimeBox>
                    <PointsBox>
                        <Typography fontSize={fontSize}>{`${hp.pointsScored} / ${hp.lessonVersion.maxPoints} ${t('myTrainings.historicalProgress.pointsShortcut')}`}</Typography>
                    </PointsBox>
                </Stack>
            ))}
        </Stack>
    );
}

export default HistoricalProgresses;